import React from 'react';
import { VideoPopup } from './FeedbackVideos/VideoPopup';

export const VideoBlogs = () => {
    return (
        <>
            <div className="container-fluid py-lg-5"
                // style={{ backgroundColor: '#d8d8d8ff' }}
                // style={{ backgroundImage: 'linear-gradient(to right, #d8d8d8, #f0f0f0)' }}
                style={{ backgroundImage: 'linear-gradient(to right, #d8d8d8, #b0c4de)' }}
                // style={{ backgroundImage: 'linear-gradient(135deg, #e0e0e0, #cfcfcf, #a9a9a9)' }}
            >
                <div className='row'>
                    <div className="col-12 col-md-10 mx-auto py-1 mb-lg-3">
                        <h3 className="fw-bold colorcharchol text-center">Video Blogs</h3>

                        <div className="zoom-in-out-box2 m-auto">
                            <hr />
                        </div>
                    </div>
                    <div className='col-12 '>
                        <div id="" className="">

                            <div className="row mb-lg-3" >
                                {/* <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review2.png" controls>
                                            <source src="Assets/Images/video/blackSpotVideo1.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>

                                <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review3.png" controls>
                                            <source src="Assets/Images/video/blackSpotVideo2.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div> */}

                                {/* <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review1.png" controls>
                                            <source src="Assets/Images/video/RTOThaneBlackSpotVideo.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div> */}
                                <VideoPopup />
                            </div>

                        </div>
                    </div>
                    <hr />
                    <div className='col-12 text-center mx-auto py-3 '>
                        <h4 className="fw-bold colorcharchol text-center ">Users Appreciate a Safer, Smarter, and More Aware Driving Experience</h4>
                        <div className="zoom-in-out-box2 m-auto mb-3">
                            <hr />
                        </div>
                        <p>
                            Users have shared highly positive feedback about the app’s vision and purpose. They appreciate its focus on real-time safety alerts and the effort to make roads safer through verified data and technology. Many users find the zero-login, multilingual approach very convenient and inclusive, allowing people from different backgrounds to use it easily. The women’s safety alerts are especially praised as a thoughtful and much-needed feature. Overall, users value the app’s practical design, life-saving potential, and commitment to public safety — describing it as a meaningful step toward smarter, safer, and more aware road usage.
                        </p>
                    </div>
                </div>

            </div>
        </>
    );
};
